import React from "react";

function CallToAction() {
  return (
    <>
      {/* START FOOTER with NEW DESIGN */}
      <div className="position-relative mb-n12">
        <div className="container">
          <div className="card bg-primary z-index-3 bg-gradient-primary-gradient">
            <div className="card-body" data-aos="fade-in">
              <section
                className="py-5 bg-transparent "
                // style={{ backgroundImage: "url(./img/shapes/waves-white.svg)" }}
                data-aos="fade-in"
              >
                <span className="mask opacity-8" />
                <div className="container position-relative z-index-2">
                  <div className="row">
                    <div className="col-lg-5 col-md-8 m-auto text-start">
                      <h5 className="text-white mb-lg-0 mb-5">
                        Have an Enquiry? Feel free to contact us
                      </h5>
                    </div>
                    <div className="col-lg-6 m-auto">
                      <div className="row">
                        <div className="col-sm-4 col-6 ps-sm-0 ms-md-auto ms-lg-auto d-flex mx-auto">
                          <a
                            href="/contact-us"
                            className="btn bg-gradient-light mb-0 ms-lg-3 ms-sm-2 mb-sm-0 mb-2 me-auto w-100 d-block"
                          >
                            Inquire Now
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CallToAction;
